module.exports = __webpack_public_path__ + "static/media/mnx.c0a840db.svg";